import React from 'react';
interface SectionCardProps {
  title?: string;
  children: ReactNode;
}
export function SectionCard({
  title,
  children
}: SectionCardProps) {
  return <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-39">
      {title && <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-40">{title}</h3>}
      {children}
    </div>;
}